import React, { useEffect, useState } from "react";
import { IoCheckmarkCircle, IoAlertCircle, IoInformationCircle } from "react-icons/io5";
import { subscribeToasts } from "./toastBus";
import styles from "./Toast.module.css";

const ICONS = {
    success: IoCheckmarkCircle,
    error: IoAlertCircle,
    info: IoInformationCircle,
};

export default function ToastContainer() {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        const unsubscribe = subscribeToasts((toast) => {
            setToasts((prev) => [...prev, toast]);
            setTimeout(() => {
                setToasts((prev) => prev.filter((t) => t.id !== toast.id));
            }, toast.duration);
        });
        return unsubscribe;
    }, []);

    if (toasts.length === 0) return null;

    return (
        <div className={styles.stack} role="status" aria-live="polite">
            {toasts.map((t) => {
                const Icon = ICONS[t.type] || ICONS.info;
                return (
                    <div key={t.id} className={`${styles.toast} ${styles[t.type] || styles.info}`}>
                        <Icon size={20} />
                        <span>{t.message}</span>
                    </div>
                );
            })}
        </div>
    );
}
